import { useEffect, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";

const useBloqueado = (todosOsClientes = [], setBloqueadoStatus, config = {}) => {
  const { salvarLocalStorage = false, chave } = config;

  const bloqueadoSelect = useSelect("bloqueado");

  const [bloqueado, setBloqueado] = useState(0); // 0 = todos
  const [fila, setFila] = useState(null);

  const optionsBloqueado = [
    { value: 0, label: "Todos" },
    { value: true, label: "Bloqueado" },
    { value: false, label: "Sem bloqueio" },
  ];

  function onChangeBloqueado(option) {
    bloqueadoSelect.upDateValue(option?.value);
    bloqueadoSelect.upDateDefaultValue(option || "");
    setBloqueado(option?.value ?? 0);

    if (salvarLocalStorage && chave) {
      localStorage.setItem(chave, JSON.stringify(option));
    }
  }

  function CleanForFilter(option) {
    onChangeBloqueado(option);
  }

  useEffect(() => {
    if (salvarLocalStorage && chave) {
      const salvo = localStorage.getItem(chave);
      try {
        if (salvo && salvo !== "undefined") {
          const obj = JSON.parse(salvo);
          setBloqueado(obj?.value ?? 0);
          onChangeBloqueado(obj);
          setFila(obj?.value ?? null);
        }
      } catch (e) {
        console.error("Erro ao fazer parse do localStorage 'bloqueado':", e);
      }
    }
  }, []);


  function SetSelectBloqueado(id) {
    const option = optionsBloqueado.find((o) => o.value === id);
    if (option) {
      onChangeBloqueado(option);
      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila !== null) {
      SetSelectBloqueado(fila);
    }
  }, [fila]);


  useEffect(() => {
    if (setBloqueadoStatus) {
      setBloqueadoStatus(bloqueado);
    }
  }, [bloqueado]);

  return {
    bloqueado,
    optionsBloqueado,
    bloqueadoSelect,
    onChangeBloqueado,
    SetSelectBloqueado,
    CleanForFilter,
  };
};

export default useBloqueado;
